<div>
  <img class="pb-4 pt-2" src="../../../../assets/images/{{image}}" aria-hidden="true">
  <app-free-offering-button link="{{link}}"
                            buttonText="{{buttonText}}"></app-free-offering-button>
</div>
